import NavList from "./NavList";

// Desktop rail only — mobile uses MobileNav drawer. `collapsible` lets the logo
// act as a collapse toggle here without changing the drawer's behaviour.
export default function Sidebar() {
  return (
    <aside className="glass rounded-[26px] p-4 hidden lg:flex lg:flex-col gap-3 h-full">
      <NavList collapsible />
    </aside>
  );
}
